import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../core/services/auth-rol.service';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderValidationAuthService extends AuthRolService {
  /**
   * @description Este metodo sirve para verificar que la persona
   * que intente verificar alguno de los reportes, si tenga los permisos necesarios
   */
  verified(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  /**
   * @description Este metodo sirve para verificar que la persona que intente
   * editar alguno de los reportes, si tenga los permisos necesarios
   */
  editReport(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  /**
   * @description Este metodo verifica que la persona que intente enviar un reporte,
   * si tenga los permisos necesarios
   */
  sendReport(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  /**
   * @description Cada tabla tendra una serie de opciones, esta permite verificar
   * si la persona en especifico podra ver la columna con todas las opciones.
   */
  viewOptions(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }
}
